import { render, staticRenderFns } from "./WorkflowActivator.vue?vue&type=template&id=1f3b9f35&scoped=true&"
import script from "./WorkflowActivator.vue?vue&type=script&lang=ts&"
export * from "./WorkflowActivator.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowActivator.vue?vue&type=style&index=0&id=1f3b9f35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b9f35",
  null
  
)

export default component.exports